import api from 'api';

const url = id => `/api/reservations/${id}/decline`;

export default {
    decline: id => api.get({path: url(id)})
}
